module.exports = __webpack_public_path__ + "img/what_app.d100e328.jpg";